import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';

import type {
	AgentManagedExtensionPlugin,
	AgentManagedExtensionPluginState,
} from '../../../common/agentManagedExtensionPluginType';
import {
	getAiManagedObjectLoadStatusByLocalIdFromPluginState,
	getCachedAiManagedObjectByLocalIdFromPluginState,
} from '../../pm-plugins/state';
import { getUpdateIntervalFromDesiredFrequency } from '../configuration';
import type { AutoUpdateIntervalOption } from './types';

type SharedStateSelectorArgs = {
	agentManagedExtensionState?: AgentManagedExtensionPluginState;
};

const sharedStateSelector = ({ agentManagedExtensionState }: SharedStateSelectorArgs) =>
	agentManagedExtensionState;

export const useAutoUpdateIntervalState = (
	api: PublicPluginAPI<[AgentManagedExtensionPlugin]> | undefined,
): {
	isFailed: boolean;
	isLoading: boolean;
	selectedUpdateInterval?: AutoUpdateIntervalOption;
} => {
	const pluginState = useSharedPluginStateWithSelector(
		api,
		['agentManagedExtension'],
		sharedStateSelector,
	);
	const localId = pluginState?.isAutoUpdateIntervalOpen
		? pluginState.autoUpdateIntervalLocalId
		: undefined;
	const aimo = getCachedAiManagedObjectByLocalIdFromPluginState(pluginState, localId);
	const loadStatus = getAiManagedObjectLoadStatusByLocalIdFromPluginState(pluginState, localId);

	return {
		isFailed: loadStatus === 'failed',
		isLoading: loadStatus === 'loading',
		selectedUpdateInterval: aimo
			? (getUpdateIntervalFromDesiredFrequency(aimo.config.desiredUpdateFrequency) ?? 'none')
			: undefined,
	};
};
